import { render, staticRenderFns } from "./ChannelConnectionView.vue?vue&type=template&id=fd01346e&scoped=true"
import script from "./ChannelConnectionView.vue?vue&type=script&lang=js"
export * from "./ChannelConnectionView.vue?vue&type=script&lang=js"
import style0 from "./ChannelConnectionView.vue?vue&type=style&index=0&id=fd01346e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01346e",
  null
  
)

export default component.exports